import {BasicEntity, BasicProperty} from '../../basic-entity-back/annotations';
import {Persona} from './persona.model';
import {ManagerCachingStrategy, SearchType} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {Uri} from "../../api/uri";
import {Idioma} from "../localizacion/idioma.model";

/**
 * Proveedor. Lo obligatorio, como en la API (`Proveedor`/`PersonaSuperclass`): email e idioma son opcionales (columnas
 * nullable; el NotBlank del email solo va en el grupo `registro` de los clientes) e `isEmpresa` es un bool que vale
 * false por defecto. Lo único que la API exige es la dirección de facturación con país (lo explica su 422).
 *
 * Se redeclaran aquí, y no en `Persona`, para no cambiar clientes, empleados ni comerciales. El formulario genérico
 * pone `required` a todo lo que no es `nullable`: sin esto el email salía obligatorio y la casilla «Empresa»
 * indeterminada (null) y obligatoria, con Guardar deshabilitado sin decir por qué.
 */
@BasicEntity({
    name: 'Proveedores',
    endpoint: 'proveedors',
    isPaginated: true,
    managerCaching: ManagerCachingStrategy.Lazy,
    type: 'Proveedor',
    modelNameProperty: "nombre"
})
export class Proveedor extends Persona {
    @BasicProperty({
        name: 'Email',
        type: PropertyType.Email(),
        nullable: true,
        searchable: SearchType.Start,
        sortable: true,
        order: 6
    })
    protected _email;

    @BasicProperty({
        name: 'Idioma',
        type: PropertyType.Uri(Idioma),
        nullable: true,
        order: 10
    })
    protected _idioma: Uri;

    /** False en el alta, como en la API: así la casilla no sale indeterminada. Lo que llega de la API lo sustituye. */
    @BasicProperty({
        name: 'Empresa',
        type: PropertyType.Boolean(),
        nullable: false
    })
    protected _isEmpresa: boolean = false;
}
